import { OpenPanel } from '@openpanel/web';
import { createContext, FC, ReactNode, useMemo } from 'react';

interface OpenPanelContextValue {
  openPanel: OpenPanel;
}

export const OpenPanelContext = createContext<OpenPanelContextValue | undefined>(undefined);

interface OpenPanelProviderProps {
  children: ReactNode;
  clientId: string;
  clientSecret?: string;
  enabled?: boolean;
}

export const OpenPanelProvider: FC<OpenPanelProviderProps> = ({ children, clientId, clientSecret, enabled = true }) => {
  const openPanel = useMemo(() => {
    return new OpenPanel({
      clientId,
      clientSecret,
      trackScreenViews: true,
      trackOutgoingLinks: true,
      trackAttributes: true,
      disabled: !clientId || !enabled, // Disable if clientId is not provided or if not enabled
    });
  }, [clientId, clientSecret, enabled]);

  return <OpenPanelContext.Provider value={{ openPanel }}>{children}</OpenPanelContext.Provider>;
};
